<template>
  <div class="pagination-container">
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      first-text="First"
      prev-text=""
      next-text="Next"
      last-text="Last"
      align="center"
    >
      <template #prev-text
        ><span class="icon"><i class="las la-angle-left"></i></span
      ></template>
      <template #next-text
        ><span class="icon"><i class="las la-angle-right"></i></span
      ></template>
    </b-pagination>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  data() {
    return {
      rows: 100,
      perPage: 10,
      currentPage: 1,
    };
  },
};
</script>
<style lang="scss">
@import "@/assets/stylesheets/application";

.pagination {
  padding: 2rem 0;
  .page-item {
    .page-link {
      border: 0;
      color: $blue-primary;
      font-weight: 700;
      font-size: 1em;
      margin-left: 3px; /* -1px */
    }
    &.active {
      .page-link {
        background-color: $blue-primary;
        color: $white;
      }
    }
  }
  .icon {
    font-size: 18px;
  }
}
</style>
